import {observable, runInAction} from "mobx";
import {ProductFolderDto} from "../Entities/Dtos";
import api from "../Services/Api";

class ProductFolderListStore {
    @observable folders: ProductFolderDto[] = []

    async load() {
        const result = await api.get('productFolder/list');
        if (result.success) {
            runInAction(() => {
                this.folders = result.data.productFolders;
            })
        }
    }
}

const productFolderListStore = new ProductFolderListStore();
export default productFolderListStore;